import { datadogLogs, LogsEvent } from '@datadog/browser-logs';
import { environment } from '../environment';
import { TRANSIENT_FETCH_MESSAGES } from './datadog-rum';

/**
 * datadogLogs.logger.error() calls (e.g. the Okta signOut() catch in
 * cleanupSessions, apps/web/src/auth.tsx) go through this Logs SDK's own
 * beforeSend, not datadog-rum.ts's — so the RUM-side transient-network
 * filters never see them. Okta's signOut() hits the network to revoke the
 * session; if that request drops (tab closing, connection flake) it throws
 * the same AuthApiError the RUM filter already treats as noise (SC-4259).
 */
export const isTransientAuthNetworkLogError = (event: LogsEvent): boolean =>
  event.error?.kind === 'AuthApiError' &&
  TRANSIENT_FETCH_MESSAGES.has(event.error.message ?? '');

// This allows us to send logs to Datadog from the browser
export const initDatadogLogs = () => {
  const env = environment.VITE_ENVIRONMENT;

  if (env !== 'local') {
    datadogLogs.init({
      clientToken: environment.VITE_DD_CLIENT_TOKEN,
      site: environment.VITE_DD_SITE,
      service: 'strength-web',
      version: environment.VITE_COMMIT_SHA,
      env,
      forwardErrorsToLogs: true,
      // This lets us log to the console and datadog in 1 line
      forwardConsoleLogs: ['warn'],
      beforeSend: (event) =>
        // Cross-origin scripts (Gainsight PX, Module Federation remotes,
        // Customer.io CDN plugins) throw opaque "Script error." events with
        // no stack or filename. Not actionable, so filter before forwarding.
        event.message !== 'Script error.' &&
        !isTransientAuthNetworkLogError(event),
      sessionSampleRate: 100,
    });
    datadogLogs.setGlobalContextProperty('team', 'strength');
  }
};
